import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from "@quickenloans-ui-suite/components/atomics"

import { testAttributes } from './Constants';
import * as styles from './InlineSourceLink.module.scss';
import handleSmooth from '../../../utilities/handleSmooth';
import {containerId as articleSourcesId} from '../../Pages/ArticlePostPage/Constants';

const scrollTo = () => 
{
    handleSmooth(`#${articleSourcesId} > div > div`);
};

const InlineSourceLink = ({ sourceNumber, content, onClick = undefined }) => (
    <span
        className={styles.inlineSourceLink}
        data-test={testAttributes.INLINE_SOURCE_LINK}
    >
        <Tooltip
            className={styles.inlineSourceLink}
            componentsProps={{
                popper: {
                    'data-testid': testAttributes.INLINE_SOURCE_LINK_TOOLTIP,
                },
            }}
            content={content}
            disableHoverListener={false}
            placement="bottom"
            size="medium"
        >
            <button
                className={styles.cite}
                type="button"
                data-testid={testAttributes.INLINE_SOURCE_LINK_BUTTON}
                onClick={scrollTo}
                {...(onClick ? { onClick } : undefined)}
            >
                <sup>{`[${sourceNumber}]`}</sup>
            </button>
        </Tooltip>
    </span>
);

InlineSourceLink.propTypes = {
    /** The number to render inside the square brackets [1] */
    sourceNumber: PropTypes.number.isRequired,
    /** The content to be rendered into the Tooltip */
    content: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
        .isRequired,
    /** Function to call when clic event is fired */
    onClick: PropTypes.func,
};

export default InlineSourceLink;
